const BindPage = () => import ('@/views/notice/Bind')
export default [
    {  path: '/notice/bind',  name:'Bind',  component: BindPage},
]